// extracted by mini-css-extract-plugin
export default {"content":"DealCard_content__PI7m9","date":"DealCard_date__8CMpe"};